// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Error icon.
 * @param {IconProps} props - The IconProps for the ErrorIcon component.
 * @returns {ReactElement} The ErrorIcon component.
 */
export const ErrorIcon = (props: IconProps) => {
  const { color = 'roseVale', ...rest } = props;
  return (
    <Icon viewBox='0 0 12 12' color={color} id='error-icon' {...rest}>
      <path
        d='M6 0.1875C2.79007 0.1875 0.1875 2.79101 0.1875 6C0.1875 9.21087 2.79007 11.8125 6 11.8125C9.20993 11.8125 11.8125 9.21087 11.8125 6C11.8125 2.79101 9.20993 0.1875 6 0.1875ZM6 10.6875C3.40941 10.6875 1.3125 8.59146 1.3125 6C1.3125 3.41027 3.4095 1.3125 6 1.3125C8.58963 1.3125 10.6875 3.40948 10.6875 6C10.6875 8.59055 8.59146 10.6875 6 10.6875ZM6.98438 8.25C6.98438 8.79279 6.54279 9.23438 6 9.23438C5.45721 9.23438 5.01562 8.79279 5.01562 8.25C5.01562 7.70721 5.45721 7.26562 6 7.26562C6.54279 7.26562 6.98438 7.70721 6.98438 8.25ZM5.07727 3.29529L5.23664 6.48279C5.24412 6.63248 5.36768 6.75 5.51754 6.75H6.48246C6.63232 6.75 6.75588 6.63248 6.76336 6.48279L6.92273 3.29529C6.93077 3.13465 6.80269 3 6.64184 3H5.35816C5.19731 3 5.06923 3.13465 5.07727 3.29529Z'
        fill='currentColor'
      />
    </Icon>
  );
};
